<script setup lang="ts">

import { isRef, onMounted, ref, unref, nextTick } from 'vue'
import { Data } from '@/stores/data'
import { ElementTip } from '@/stores/ElementTip'
import { Utill } from '@/stores/Utill'
import { useRoute, useRouter } from 'vue-router'
import { Delete, RefreshRight } from '@element-plus/icons-vue'
import emitter from '@/stores/mitt'
const route = useRoute()
const router = useRouter()
const resourceType = (route.params.resourceType ? route.params.resourceType : '') as string
const $emit = defineEmits([
  'stopMassage',
  'sendQuestion',
  'upWjClickHandler',
  'clickCard',
  'uploadBtnClick',
  'refreshAllMessage',
])
let def = defineProps({
  isSending: {
    type: Boolean,
    default: false,
  },
  isStartSteam: {
    type: Boolean,
    default: false,
  },
  isApplicationLink: {
    type: Boolean,
    default: false,
  },
  aQSelectedText: {
    type: String,
    default: '',
  }
})
var sendText = ref("") //输入框文字

let enterTextArea = ref<HTMLInputElement | null>(null)
const isWrap = ref(false) //回车换行
// watch(
//   () => sendText.value,
//   (newValue, oldValue) => {
//     // const currentText = textarea.value;
//     const currentText = newValue
//     let currLen = currentText.length

//     let wrapL = wrapLength(currentText)
//     currLength.value = currLen - wrapL
//     deleteNMaxLeng.value = Data.zwMaxLength.value + wrapL
//     console.log(
//       currLength.value,
//       '<<currLength.value>>>',
//       wrapL,
//       '<<deleteNMaxLeng.value>>',
//       deleteNMaxLeng.value
//     )
//     textarea.value = currentText.substring(0, maxLength + wrapL)
//   }
// )



//获取输入框的默认显示文字
function getInputPlaceholder() {
  let syNUm = 'shift+回车可换行'
  let str = '请输入您的具体问题，越清楚越好;' + syNUm
  if (resourceType) {
    str = syNUm
  }
  if (def.isApplicationLink) {
    str = '请输入您的具体问题，越清楚越好'
  }

  if (def.isSending) {
    str = '请耐心等待小鸿把话说完……'
  } else if (Data.uploadDocumentsData.documentsData.length > 0) {
    str = Data.uploadDocumentsData.documentsData[0].value.text + "；" + syNUm
  }

  return str
}
//暂停回答
function stopMassage() {
  $emit('stopMassage')
}

// watch(
//   () => sendText.value,
//   (newValue, oldValue) => {
//     if (newValue) {
//       if (sendText.value && sendText.value.endsWith('\n')) {
//         console.log(sendText.value.endsWith('\n'));
//         sendText.value = sendText.value.slice(0, -1)
//         console.log(sendText.value);
//       }
//       isWrap.value = newValue.includes('\n');
//     }

//   }
// )

const appLink = async () => {
  try {
    await router.push({ name: 'answers' });
    emitter.emit('appLink-QA', sendText.value)
  } catch (error) {
    console.error('路由跳转失败:', error);
  }
};

//点击发送按钮
function clickSend() {
  if (Utill.showLoginDialog()) {
    return
  }

  if (def.isApplicationLink) {
    appLink()
    return
    // sendText.value = ''

  }
  if (Data.uploadDocumentsData.documentsData.length > 0) {
    //是否状态都是成功
    const hasLoadingState = Data.uploadDocumentsData.documentsData.every(
      (item) => item.value.loadingState === 2
    )
    if (hasLoadingState) {
      let _sentText = Data.uploadDocumentsData.documentsData[0].value.text
      if (sendText.value) {
        Data.uploadDocumentsData.documentsData[0].value.text = sendText.value
        _sentText = sendText.value
      }
      let arr = Data.uploadDocumentsData.documentsData.concat();

      arr.forEach((item, index) => {
        if (isRef(item)) {
          arr[index] = unref(item);
        }
      });
      console.log(">>>arr>>>", arr)
      $emit('sendQuestion', _sentText, {
        upDataId: {
          wjGroup: Data.uploadDocumentsData.wjGroup,
          data: arr,
        },
      })
      sendText.value = '';
      Data.uploadDocumentsData.documentsData = [];
      Data.uploadDocumentsData.wjGroup = ''
      // ={ 'wjGroup': '','documentsData': [] as any[]}
    } else {

      ElementTip.warningTip('识别到失败文件，请检查后再发送～')
    }
  } else if (sendText.value) {
    const isBlank = /^\s*$/.test(sendText.value);
    if (isBlank) {
      console.log('内容全是空格和换行符');
    } else {
      $emit('sendQuestion', sendText.value, { selectText: def.aQSelectedText })
      sendText.value = ''
      isWrap.value = false
      console.log(isWrap.value)
    }
    // sendQuestion(sendText.value)   newCoursewareDetail(wjData.value.text, '', { upDataId: { wjId } })
  }
}
function upWjClickHandler() {
  console.log(">>upWjClickHandler>>22>")
  $emit('upWjClickHandler')
}
function openUploadeMode() {
  if (Data.uploadDocumentsData.documentsData.length > 0) {
    $emit('uploadBtnClick')
  } else {
    $emit('clickCard', '文档问答')
  }

  // clickCard('文档问答')
}
function isShowSend() {
  if (Data.uploadDocumentsData.documentsData.length > 0) {
    //是否还有加载中的文件
    const hasLoadingStateOne = Data.uploadDocumentsData.documentsData.some(
      (item) => item.value.loadingState == 1
    )
    if (!hasLoadingStateOne) {
      //没有加载中的状态了
      return true
    }
  } else {
    if (sendText.value && sendText.value.length > 0) {
      const isBlank = /^\s*$/.test(sendText.value);
      if (isBlank) {
        console.log('内容全是空格和换行符');
        return false
      } else {
        return true
      }
    }
  }

  if (def.isApplicationLink == true) {
    return true
  }
  return false
}
function handlePaste(event: ClipboardEvent) {
  if (!event.clipboardData) {
    return
  }
  // 获取剪贴板中的文本
  let text = event.clipboardData?.getData('text/plain');
  if (Utill.isURL(text)) {
    text = text + " ";

  }
  //       // 对文本进行格式化或验证
  //       text = text+" 来自粘贴";
  //       // 设置输入值
  sendText.value = sendText.value + text;
  //       // 阻止默认行为
  event.preventDefault();
  // console.log(">>>>>黏贴》》》》",sendText.value)
}
function handleKeydown(event: KeyboardEvent) {
  if (event.key === 'Enter') {
    if (def.isApplicationLink == true) {
      // 教育应用页输入框不换行
      event.preventDefault();
      clickSend();
      return
    }
    if (event.shiftKey) {
      // Shift+Enter 换行
      event.preventDefault();
      insertNewLineAtCursor();
    } else {
      // Enter 发送
      // @keydown.enter="clickSend"
      event.preventDefault();
      clickSend();
    }
  }
}
function insertNewLineAtCursor() {
  const textarea = document.activeElement as HTMLTextAreaElement;
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;

  // 在光标位置插入换行符
  sendText.value =
    sendText.value.slice(0, start) + '\n' + sendText.value.slice(end);

  // 将光标移到换行后的正确位置
  nextTick(() => {
    textarea.selectionStart = textarea.selectionEnd = start + 1;
    requestAnimationFrame(() => {
      handleInput();
    });
  });
}

// 清空对话
function refreshAllMessage() {
  sendText.value = null;
  $emit('refreshAllMessage')
}

const handleInput = () => {
  if (enterTextArea.value) {
    enterTextArea.value.style.height = 'auto';
    const scrollHeight = Math.min(enterTextArea.value.scrollHeight, 66);
    enterTextArea.value.style.height = `${scrollHeight}px`;
  }
};
</script>

<template>
  <div class="composer">
    <div v-if="!isApplicationLink" class="refresh-ctr" @click="refreshAllMessage"
      :class="isStartSteam ? 'refresh-disabled' : ''">
      <img class="send-img" src="@/assets/refresh-icon.png" alt="">
    </div>
    <div v-else class="search-ctr">
      <img class="search-img" src="@/assets/xiaohong/app-link-search.png" alt="">
    </div>
    <div class="textarea-ctr">
      <textarea class="textarea-item" ref="enterTextArea" v-model="sendText" @keydown="handleKeydown" @paste="handlePaste"
        :placeholder="getInputPlaceholder()" :disabled="isSending" rows="1" @input="handleInput"></textarea>
    </div>
    <div class="Composer-actions" data-action-icon="paper-plane">
      <el-button type="primary" class="send-btn" :disabled="!isShowSend()" @click="clickSend" v-if="!isStartSteam" circle>
        <img class="send-img" src="@/assets/send.png" alt="">
      </el-button>
      <el-button type="primary" @click="stopMassage" v-else circle>
        <img class="send-img" src="@/assets/stop.svg" alt="">
      </el-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.composer {
  -ms-flex-align: end;
  align-items: flex-end;
  display: -ms-flexbox;
  display: flex;
  padding: 8px;

  position: relative;
  width: 100%;
  background: #ffffff;
  margin: auto;
  border-radius: 20px;
  cursor: auto;
}

.composer:hover {
  box-shadow: 0px 5px 12px 0px #E0E7F6;
}

.more-rows {
  border-radius: 12px;
}

.gongju-ctr {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  background: #ffffff;
  border-radius: 50%;
  margin-right: 8px;
}

.gongju-ctr img {
  width: 18px;
}

.lw-tip-ctr {
  position: absolute;
  z-index: 1;
  top: -35px;
  color: #fff;
}

.tip-body {
  border-radius: 8px;
  opacity: 1;
  background: #3b3b3b;
  padding: 8px;
  display: flex;
  align-items: center;
}

.tip-body::before {
  content: ' ';
  position: absolute;
  border: 9px solid transparent;
  width: 0;
  height: 0;
  border-bottom-color: #3b3b3b;
  left: 53px;
  bottom: -16px;
  rotate: 180deg;
  transform: rotate(180deg);
}

.lw-ctr {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  padding-top: 9px;
  gap: 10px;
  padding-left: 10px;
}

.lw-ico {
  width: 18px;
  height: 18px;
}

.fengexian {
  width: 1px;
  background: #ccc;
  height: 20px;
}

.textarea-ctr {
  width: 100%;
  display: flex;
  padding: 1px 0;
  flex: 1;
}

.textarea-item {
  width: 100%;
  height: auto;
  resize: none;
  border: none !important;
  line-height: 22px !important;
  overflow: hidden;
  overflow-y: auto;
  min-height: 22px;
  max-height: 66px;
  box-sizing: border-box;
  outline: none;
  background-color: #fff;
  caret-color: #485CEC;
  padding: 0;
  margin: 0;
}

.textarea-item:hover {
  scrollbar-width: auto;
}

.textarea-item::-webkit-scrollbar {
  display: block !important;
}

.moreRows {
  :deep(.el-textarea__inner) {
    border-radius: 12px;
  }
}

.Composer-actions {
  margin-left: 12px;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  :deep(.el-button) {
    width: 24px;
    height: 24px;
    padding: 0;
    --el-button-hover-bg-color: #5D6EEB !important;
  }
}

.send-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  cursor: pointer;
  border-radius: 50%;
  border: none !important;
}

.send-img {
  width: 14px;
  height: 14px;
}

.left-ctr {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.refresh-ctr {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  background: #ffffff;
  border-radius: 50%;
  margin-right: 12px;
  font-size: 16px;
  color: #485CEC;
  border: 1px solid rgba(72, 92, 236, 0.1);
}

.refresh-disabled {
  color: rgba(72, 92, 236, 0.5);
  cursor: not-allowed;
}

.search-ctr {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  margin-left: 12px;
  margin-right: 22px;
  padding: 4px;
}

.search-img {
  width: 16px;
  height: 16px;
}
</style>